module.exports = __webpack_public_path__ + "img/box-time.286b81b9.svg";